import { Link, useLocation } from 'react-router-dom'
import './Orders.css'

export function OrdersTabs() {
  const { pathname } = useLocation()
  return <nav className="orders-switch" aria-label="وضعیت سفارش‌ها">
    <Link to="/" aria-current={pathname === '/' ? 'page' : undefined}>در حال پردازش</Link>
    <Link to="/shipping" aria-current={pathname === '/shipping' ? 'page' : undefined}>منتظر ارسال</Link>
  </nav>
}
